var map = {
	"./cs.json": 1070,
	"./da.json": 1071,
	"./de.json": 1072,
	"./en.json": 1073,
	"./et.json": 1074,
	"./fi.json": 1075,
	"./fm.json": 1076,
	"./fr.json": 1077,
	"./it.json": 1078,
	"./lt.json": 1079,
	"./lv.json": 1080,
	"./nl.json": 1081,
	"./no.json": 1082,
	"./pl.json": 1083,
	"./ru.json": 1084,
	"./sv.json": 1085,
	"./uk.json": 1086,
	"./zh.json": 1087
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1069;